/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';

class Svg extends React.Component{
    static get propTypes() {
        return {
            svgString: PropTypes.string.isRequired,
            style: PropTypes.object
        };
    }
    render() {
        return (
            <svg aria-hidden="true"
                focusable="false"
                style={this.props.style ? this.props.style : null}
                className={'pe-icon--' + this.props.svgString}>
                <use xlinkHref={'#' + this.props.svgString}/>
            </svg>
        );
    }
}

export default Svg;



// WEBPACK FOOTER //
// ./src/components/widgets/Svg/Svg.js